import { getMeta } from './helpers';

// Set webpack public asset url
window.__webpack_public_path__ = getMeta('theme-url');

import { Application } from '@hotwired/stimulus';
import AxiosFormController from './controllers/axios-form-controller';
import ExpandableController from './controllers/expandable-controller';
import ModalController from './controllers/modal-controller';
import SliderController from './controllers/slider-controller';
import SelectController from './controllers/select-controller';
import LeafletMapsController from './controllers/leaflet-maps-controller';
import TabController from './controllers/tab-controller';
import SearchController from './controllers/search-controller';

require('./navigation');
require('./lightbox');

const application = Application.start();

application.register('axios-form', AxiosFormController);
application.register('modal', ModalController);
application.register('slider', SliderController);
application.register('expandable', ExpandableController);
application.register('select', SelectController);
application.register('map', LeafletMapsController);
application.register('tab', TabController);
application.register('search', SearchController);

document.querySelectorAll('ol[start], ul[start]').forEach((list) => {
    list.style.setProperty('--start', list.getAttribute('start'));
});
